import React, { FC } from 'react';
import * as Styled from './TicketCreate.styles';
import * as TicketService from '@modules/ticket/service';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/function';
import { useTranslations } from '@shared/modules/translation/hooks';
import { InternationalizeString } from '@shared/modules/translation/model';
import TicketCreateForm from '@modules/ticket/components/create/TicketCreateForm';
import { useSendTask } from '@core/http/hooks';
import { CreateTicketParams } from '@modules/ticket/model';
import { navigateTo } from '@shared/utils/routes';
import { Profile } from '@modules/auth/model';

interface TicketCreateProps {
  serialId: string;
  answerId: string;
  diagnosticName: InternationalizeString;
  diagnosticNumber: number;
  email: string;
  profile: Profile;
}

const TicketCreate: FC<TicketCreateProps> = ({
  serialId,
  answerId,
  diagnosticName,
  diagnosticNumber,
  email,
  profile,
}) => {
  const translations = useTranslations();

  const [loading, create] = useSendTask(TicketService.createTicket);

  const handleSubmit = (params: CreateTicketParams) => {
    pipe(
      () => create(serialId, params),
      TE.chainFirstIOK(
        () => () => navigateTo('failureSuccess', { diagnostic_number: diagnosticNumber, answer_id: answerId }),
      ),
    )();
  };

  return (
    <Styled.TicketCreateContainer>
      <Styled.TicketCreateTitle>{translations.tickets.create.title}</Styled.TicketCreateTitle>

      <Styled.TicketCreateText>{translations.tickets.create.text}</Styled.TicketCreateText>

      <TicketCreateForm
        loading={loading}
        onSubmit={handleSubmit}
        serialId={serialId}
        answerId={answerId}
        diagnosticName={diagnosticName}
        email={email}
        profile={profile}
      />
    </Styled.TicketCreateContainer>
  );
};

export default TicketCreate;
